export default __webpack_public_path__ + "static/media/Subject_to_change.e8dc2f13.svg";